import { useEffect } from 'react'

import { Layout } from '../../components'
import { AccessKeysPanel } from '../../components/panels'
import { DRAWER_KEYS } from '../../store/constants'

import AuthPage from './AuthPage'

/**
 * @description Renders the PlanGroupsPage component.
 * The component is wrapped in the AuthPage component to ensure that the user is authenticated before accessing the page.
 * 
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered PlanGroupsPage component.
 */
const PlanGroupsPage = () => {

    useEffect(() => {
        document.title = 'Chaves de Acesso | LCD'
    }, [])

    return (
        <AuthPage>
            <Layout selectedKey={DRAWER_KEYS.ACCESS_KEYS} >
                <AccessKeysPanel />
            </Layout>
        </AuthPage>
    )
}

export default PlanGroupsPage